import React from 'react';
import { scheduleActions } from '../../redux-saga/actions';
import { PeriodPicker } from '../CrewSchedulingNavigation/PeriodPicker';
import { Button, Divider, Drawer, Form, Layout, Popover } from 'antd';
import ActionsDropdown, { VersionButton, MinViewCheckbox } from '../../helper';
import { CrewSchedulingFilters } from '../CrewSchedulingFilters';
import { useDispatch, useSelector } from 'react-redux';
import { getIsDrawerVisible, getIsFilterDrawerPinned } from '../../redux-saga/selectors';
import { isDisplayFilters } from '../utils';
import { getCompanySettings, getUserRole } from '../../../../../../redux/selectors';
import { PushpinTwoTone } from '@ant-design/icons';
import './filterDrawer.css';
import { BartSync } from '../Integrations/BART/BartSync';
import { ScheduleFileImport } from '../Integrations/FileImport/ScheduleFileImport';
import MODAL_MODE from '../../../../common/constants';
import { useFeatureFlags } from '../../../../../../utils/feature-flags/FeatureFlagsProvider';
import { isMobile } from 'react-device-detect';
import { TimelineSelector } from '../Timeline/TimelineSelector/TimelineSelector';

const { Sider } = Layout;

export const FilterDrawer = () => {
  const dispatch = useDispatch();
  const isDrawerVisible = useSelector(getIsDrawerVisible);
  const isFilterPinned = useSelector(getIsFilterDrawerPinned);
  const userRoles = useSelector(getUserRole);
  const companySettings = useSelector(getCompanySettings);
  const width = (isMobile? window.innerWidth : 500)
  const togglePin = () => {
    dispatch(scheduleActions.setIsFilterDrawerPinned(!isFilterPinned));
  };
  const openPrinterModal = () => {
    dispatch(
      scheduleActions.setRemotePrinterModalMode({
        open: true,
        mode: MODAL_MODE.create,
      }),
    );
  };

  if (isFilterPinned) {
    return (
      <>
        <Sider width="400px" className="sider">
          <div className="inner-sider">
            <span style={{ fontSize: '18px', fontWeight: '600' }}>Filters</span>
            <Popover content="Click to unpin">
              <Button
                icon={<PushpinTwoTone twoToneColor="#fff" />}
                onClick={togglePin}
                type="primary"
                style={{ borderRadius: '4px' }}
              />
            </Popover>
          </div>
          <div style={{ padding: '20px' }}>
            <PeriodPicker />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                justifyContent: 'space-between',
                marginTop: '2rem',
              }}
            >
              <BartSync />
              <ScheduleFileImport />
              {companySettings?.RemotePrinter && <Button onClick={openPrinterModal}>Export</Button>}
            </div>
            {isMobile && <VersionButton />} {isMobile && <MinViewCheckbox />} 
            {isMobile && <TimelineSelector />}
            <Divider />
            <ActionsDropdown />
            <Divider />
            {isDisplayFilters(userRoles, companySettings) && (
              <div style={{ marginTop: 16 }}>
                <Form layout="vertical">
                  <CrewSchedulingFilters />
                </Form>
              </div>
            )}
          </div>
        </Sider>
      </>
    );
  }

  return (
    <Drawer
      width={width}
      title={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span style={{ fontSize: '18px', fontWeight: '600' }}>Filters</span>
          <Popover content="Click to pin">
            <Button icon={<PushpinTwoTone />} onClick={togglePin} />
          </Popover>
        </div>
      }
      placement="right"
      onClose={() => dispatch(scheduleActions.setIsDrawerVisible(false))}
      open={isDrawerVisible}
    >
      <PeriodPicker />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          marginTop: '2rem',
          justifyContent: 'space-between'
        }}
      >
        <BartSync />
        <ScheduleFileImport />
        {companySettings?.RemotePrinter && <Button onClick={openPrinterModal}>Export</Button>}
      </div>
      {isMobile && <VersionButton />} {isMobile && <MinViewCheckbox />} 
      {isMobile && <TimelineSelector />}
      <Divider />
      <ActionsDropdown />
      <Divider />
      {isDisplayFilters(userRoles, companySettings) && (
        <div style={{ marginTop: 16 }}>
          <Form layout="vertical">
            <CrewSchedulingFilters />
          </Form>
        </div>
      )}
    </Drawer>
  );
};
